module.exports = __webpack_public_path__ + "img/zero_sales_days_analysis.e79701f6.svg";